import React, { createContext, ReactNode, useContext } from 'react';

// Define the shape of the context value
interface ILocalContextValue {
    content: Record<string, any>; // Adjust the type as needed for your content
}

// Create the context with a default value (optional)
const LocalContext = createContext<ILocalContextValue | undefined>(undefined);

// Create a provider component
interface ILocalContextProviderProps {
    value: ILocalContextValue;
    children: ReactNode;
}

export const LocalContextProvider: React.FC<ILocalContextProviderProps> = ({ value, children }) => {
    return <LocalContext.Provider value={value}>{children}</LocalContext.Provider>;
};

// Custom hook to consume the context
export const useLocalContext = (): ILocalContextValue => {
    const context = useContext(LocalContext);
    if (!context) {
        throw new Error('useMyLocalContext must be used within a MyLocalContextProvider');
    }
    return context;
};
